import { bg } from 'date-fns/locale';
import { ButtonOption } from '../types/mold';

export interface ErrorCode {
    code: string;
    description: string;
    errorType: string;
}

export interface ErrorType {
    errorType: string;
    name: string;
    description: string;
    cause: string;
    guidance: string;

    //For display purposes
    bgColor?: string; // Background color for the error type
    textColor?: string; // Text color for the error type
}

export const errorCodes: ErrorCode[] = [
    {
        "code": "E01",
        "description": "Hot Runner มีปัญหา ( รั่ว / ขาด / เสีย / ไม่ปกติ )",
        "errorType": "hotRunner"
    },
    {
        "code": "E02",
        "description": "วาล์วเกท Hot Runner แตก",
        "errorType": "hotRunner"
    },
    {
        "code": "E03",
        "description": "วาล์วเกท Hot Runner ไหม้",
        "errorType": "hotRunner"
    },
    {
        "code": "E04",
        "description": "วาล์วเกท Hot Runner ไม่เปิด",
        "errorType": "hotRunner"
    },
    {
        "code": "E05",
        "description": "วาล์วเกท Hot Runner เสีย",
        "errorType": "hotRunner"
    },
    {
        "code": "E06",
        "description": "วาล์วเกท Hot Runner ขาด",
        "errorType": "hotRunner"
    },
    {
        "code": "E07",
        "description": "ไม่มีลิมิทกระทุ้ง/ สไลด์",
        "errorType": "electrical"
    },
    {
        "code": "E08",
        "description": "สายไฟต่อลิมิทกระทุ้ง/ สไลด์ขาด",
        "errorType": "electrical"
    },
    {
        "code": "E09",
        "description": "ลิมิทกระทุ้ง/ ลิมิทสไลด์ชำรุด",
        "errorType": "electrical"
    },
    {
        "code": "E10",
        "description": "ไม่มีเซฟตี้สไลด์",
        "errorType": "electrical"
    },
    {
        "code": "E11",
        "description": "เข็มกระทุ้งหัก",
        "errorType": "mechanical"
    },
    {
        "code": "E12",
        "description": "เข็มกระทุ้งแตก",
        "errorType": "mechanical"
    },
    {
        "code": "E13",
        "description": "เข็มกระทุ้งไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "E14",
        "description": "เข็มกระทุ้งขาด",
        "errorType": "mechanical"
    },
    {
        "code": "E15",
        "description": "เช็มกระทุ้งสูง",
        "errorType": "mechanical"
    },
    {
        "code": "E16",
        "description": "เข็มกระทุ้งไม่กลับ",
        "errorType": "mechanical"
    },
    {
        "code": "E17",
        "description": "เข็มกระทุ้งไม่ได้ใส่",
        "errorType": "mechanical"
    },
    {
        "code": "E18",
        "description": "เข็มกระทุ้งใส่ผิด",
        "errorType": "mechanical"
    },
    {
        "code": "E19",
        "description": "น๊อตยึดแผ่นรันเนอร์ขาด",
        "errorType": "mechanical"
    },
    {
        "code": "E20",
        "description": "น๊อตยึดก้อน Insert ขาด",
        "errorType": "mechanical"
    },
    {
        "code": "E21",
        "description": "น๊อตยึดแผ่นกระชากขาด",
        "errorType": "mechanical"
    },
    {
        "code": "E22",
        "description": "น๊อตยึดแผ่นล็อกแม่พิมพ์ขาด",
        "errorType": "mechanical"
    },
    {
        "code": "E23",
        "description": "น๊อตล็อกขาตั้งแม่พิมพ์ขาด",
        "errorType": "mechanical"
    },
    {
        "code": "E24",
        "description": "น็อตยึด Parting Lock ขาด,เกลียวเสีย",
        "errorType": "mechanical"
    },
    {
        "code": "E25",
        "description": "น๊อตยึดสกรูบูสขาด",
        "errorType": "mechanical"
    },
    {
        "code": "E26",
        "description": "ทำสกูรบูสใหม่",
        "errorType": "mechanical"
    },
    {
        "code": "E27",
        "description": "ข้อต่อน้ำหัก",
        "errorType": "coolingSystem"
    },
    {
        "code": "E28",
        "description": "ข้อต่อน้ำรั่ว",
        "errorType": "coolingSystem"
    },
    {
        "code": "E29",
        "description": "เกลียวข้อต่อน้ำเสีย",
        "errorType": "coolingSystem"
    },
    {
        "code": "E30",
        "description": "เปลี่ยนขนาด รู ข้อต่อน้ำ",
        "errorType": "coolingSystem"
    },
    {
        "code": "E31",
        "description": "เสาแม่พิมพ์หัก",
        "errorType": "mechanical"
    },
    {
        "code": "E32",
        "description": "ก้อนอุดเกทหลุด",
        "errorType": "mechanical"
    },
    {
        "code": "E33",
        "description": "อุดเกทฉีด",
        "errorType": "mechanical"
    },
    {
        "code": "E34",
        "description": "เปิดเกทที่อุดฉีด",
        "errorType": "mechanical"
    },
    {
        "code": "M01",
        "description": "แม่พิมพ์เป็นรอยไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "M02",
        "description": "แม่พิมพ์เป็นคราบแก็ส",
        "errorType": "mechanical"
    },
    {
        "code": "M03",
        "description": "แม่พิมพ์เป็นรอยยุบขอบ",
        "errorType": "mechanical"
    },
    {
        "code": "M04",
        "description": "แม่พิมพ์เป็นรอยขีดข่วน",
        "errorType": "mechanical"
    },
    {
        "code": "M05",
        "description": "แม่พิมพ์เป็นสนิม",
        "errorType": "mechanical"
    },
    {
        "code": "M06",
        "description": "แม่พิมพ์เป็นคราบน้ำ, รอยน้ำรั่ว",
        "errorType": "coolingSystem"
    },
    {
        "code": "M07",
        "description": "แม่พิมพ์เป็นคราบน้ำมัน",
        "errorType": "mechanical"
    },
    {
        "code": "M08",
        "description": "แม่พิมพ์เป็นรอยแตก",
        "errorType": "mechanical"
    },
    {
        "code": "M09",
        "description": "แม่พิมพ์ผิวทรายไม่เหมือน",
        "errorType": "mechanical"
    },
    {
        "code": "M10",
        "description": "แผ่นรันเนอร์เป็นสนิม",
        "errorType": "mechanical"
    },
    {
        "code": "M11",
        "description": "แผ่นรันเนอร์ไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "M12",
        "description": "แผ่นรันเนอร์ไม่เด้ง",
        "errorType": "mechanical"
    },
    {
        "code": "M13",
        "description": "แผ่นรันเนอร์เสียรูป",
        "errorType": "mechanical"
    },
    {
        "code": "M14",
        "description": "แผ่นรันเนอร์ไม่ได้ขนาด",
        "errorType": "mechanical"
    },
    {
        "code": "M15",
        "description": "สกรูบูซแตก",
        "errorType": "mechanical"
    },
    {
        "code": "M16",
        "description": "สกรูบูซไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "M17",
        "description": "สกรูบูซเป็นสนิม",
        "errorType": "mechanical"
    },
    {
        "code": "M18",
        "description": "สกรูบูซเสียรูป / เป็นรอย",
        "errorType": "mechanical"
    },
    {
        "code": "M19",
        "description": "ลิปเตอร์ (Lifter) หัก",
        "errorType": "mechanical"
    },
    {
        "code": "M20",
        "description": "ลิปเตอร์ (Lifter) แตก",
        "errorType": "mechanical"
    },
    {
        "code": "M21",
        "description": "ลิปเตอร์ (Lifter) ไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "M22",
        "description": "ลิปเตอร์ (Lifter) งอ",
        "errorType": "mechanical"
    },
    {
        "code": "M23",
        "description": "ลิปเตอร์ (Lifter) เป็นสนิม",
        "errorType": "mechanical"
    },
    {
        "code": "M24",
        "description": "ลิปเตอร์ (Lifter) ร้าว",
        "errorType": "mechanical"
    },
    {
        "code": "M25",
        "description": "แองกูล่าร์ (Angular) หัก",
        "errorType": "mechanical"
    },
    {
        "code": "M26",
        "description": "แองกูล่าร์ (Angular) ไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "M27",
        "description": "แองกูล่าร์ (Angular) เสียรูป",
        "errorType": "mechanical"
    },
    {
        "code": "M28",
        "description": "ก้อนสไลด์หัก",
        "errorType": "mechanical"
    },
    {
        "code": "M29",
        "description": "ก้อนสไลด์แตก",
        "errorType": "mechanical"
    },
    {
        "code": "M30",
        "description": "ก้อนสไลด์ไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "M31",
        "description": "ก้อนสไลด์เป็นสนิม",
        "errorType": "mechanical"
    },
    {
        "code": "M32",
        "description": "ก้อนสไลด์เป็นรอยขูด",
        "errorType": "mechanical"
    },
    {
        "code": "M33",
        "description": "ใส่ก้อนสไลด์ผิด",
        "errorType": "mechanical"
    },
    {
        "code": "M34",
        "description": "น้ำรั่วก้อนสไลด์",
        "errorType": "coolingSystem"
    },
    {
        "code": "M35",
        "description": "ก้อนสไลด์เด้งไม่สุด",
        "errorType": "mechanical"
    },
    {
        "code": "M36",
        "description": "อินเสิร์ทหัก",
        "errorType": "mechanical"
    },
    {
        "code": "M37",
        "description": "อินเสิร์ทแตก",
        "errorType": "mechanical"
    },
    {
        "code": "M38",
        "description": "อินเสิร์ทร้าว",
        "errorType": "mechanical"
    },
    {
        "code": "M39",
        "description": "อินเสิร์ทไหม้",
        "errorType": "mechanical"
    },
    {
        "code": "M40",
        "description": "อินเสิร์ทเป็นสนิม",
        "errorType": "mechanical"
    },
    {
        "code": "M41",
        "description": "อินเสริท์สูง",
        "errorType": "mechanical"
    },
    {
        "code": "M42",
        "description": "ใส่อินเสิร์ทผิด",
        "errorType": "mechanical"
    },
    {
        "code": "M43",
        "description": "อินเสริท์เสียรูป (งอ, บิด,)",
        "errorType": "mechanical"
    },
    {
        "code": "M44",
        "description": "ถอดก้อนอินเสิร์ทเปลี่ยน Part",
        "errorType": "mechanical"
    },
    {
        "code": "M45",
        "description": "ท่อน้ำตันด้าน Core",
        "errorType": "coolingSystem"
    },
    {
        "code": "M46",
        "description": "ท่อน้ำตันด้าน Cavity",
        "errorType": "coolingSystem"
    },
    {
        "code": "M47",
        "description": "ท่อน้ำตัน Slide",
        "errorType": "coolingSystem"
    },
    {
        "code": "M48",
        "description": "น้ำมันไฮดรอริครั่ว",
        "errorType": "coolingSystem"
    },
    {
        "code": "M49",
        "description": "สายเทอโมมิเตอร์ฮิตเตอร์ขาด",
        "errorType": "electrical"
    },
    {
        "code": "M50",
        "description": "ฮิตเตอร์เสีย / ขาด",
        "errorType": "electrical"
    },
    {
        "code": "M51",
        "description": "สปริงแตก",
        "errorType": "mechanical"
    },
    {
        "code": "M52",
        "description": "หมุนเข็มเปลี่ยน พ.ศ / Part",
        "errorType": "mechanical"
    },
    {
        "code": "P01",
        "description": "ชิ้นงานเป็นขั้วขาว",
        "errorType": "productDefect"
    },
    {
        "code": "P02",
        "description": "ชิ้นงานขั้วติด",
        "errorType": "productDefect"
    },
    {
        "code": "P03",
        "description": "ชิ้นงานเป็นครีบ (BARI, Flash)",
        "errorType": "productDefect"
    },
    {
        "code": "P04",
        "description": "ชิ้นงานไม่ได้สเป๊ก",
        "errorType": "productDefect"
    },
    {
        "code": "P05",
        "description": "ชิ้นงานเป็นรอยไหม้",
        "errorType": "productDefect"
    },
    {
        "code": "P06",
        "description": "ชิ้นงานเสียรูป",
        "errorType": "productDefect"
    },
    {
        "code": "P07",
        "description": "ชิ้นงานฉีดไม่เต็ม",
        "errorType": "productDefect"
    },
    {
        "code": "P08",
        "description": "ชิ้นงานเป็นรอยแตก,ร้าว",
        "errorType": "productDefect"
    },
    {
        "code": "P09",
        "description": "ชิ้นงานติดแม่พิมพ์",
        "errorType": "productDefect"
    },
    {
        "code": "P10",
        "description": "ชิ้นงานเป็นรอยคราบ",
        "errorType": "productDefect"
    },
    {
        "code": "P11",
        "description": "ชิ้นงานเป็นรอยเบียด /รอยขูด",
        "errorType": "productDefect"
    },
    {
        "code": "P12",
        "description": "ชิ้นงานเป็นรอยกระทุ้งสูง",
        "errorType": "productDefect"
    },
    {
        "code": "P13",
        "description": "ชิ้นงานเป็นรอยนูน",
        "errorType": "productDefect"
    },
    {
        "code": "P14",
        "description": "ชิ้นงานเป็นรอยกระดาษทราย",
        "errorType": "productDefect"
    },
    {
        "code": "P15",
        "description": "ชิ้นงานเป็นรอยยุบ,บุ๋ม",
        "errorType": "productDefect"
    },
    {
        "code": "P16",
        "description": "ชิ้นงานติดแม่พิมพ์",
        "errorType": "productDefect"
    },
    {
        "code": "P17",
        "description": "ขั้วชิ้นงานติดแม่พิมพ์",
        "errorType": "productDefect"
    },
    {
        "code": "P18",
        "description": "ชิ้นงานผิวมัน,วาว",
        "errorType": "productDefect"
    },
    {
        "code": "P19",
        "description": "ชิ้นงานเป็นรอยต่อ,รอยประสาน(Wled Line)",
        "errorType": "productDefect"
    },
    {
        "code": "P20",
        "description": "ชิ้นงานเป็นรอยคลื่น(Flow Mark)",
        "errorType": "productDefect"
    },
    {
        "code": "P21",
        "description": "ชิ้นงานเป็นรอยกระทุ้งขาว(Eject Mark)",
        "errorType": "productDefect"
    },
    {
        "code": "P22",
        "description": "ชิ้นงานเป็นจุดดำ,จุดแดง",
        "errorType": "productDefect"
    },
    {
        "code": "P23",
        "description": "ชิ้นงานเป็นเศษพลาสติก",
        "errorType": "productDefect"
    },
    {
        "code": "P24",
        "description": "ชิ้นงานเป็นสีลาย",
        "errorType": "productDefect"
    }
]

export const errorTypeList: ErrorType[] = [
    {
        "errorType": "hotRunner",
        "name": "Hot Runner",
        "description": "Hot Runner รั่ว/ขาด/เสีย/ไม่เปิด",
        "cause": "ระบบไฟฟ้าขัดข้อง, การบำรุงรักษาไม่เพียงพอ",
        "guidance": "ตรวจสอบวงจรไฟฟ้า, เปลี่ยนอุปกรณ์ Hot Runner, ปรับตั้งค่าใหม่",
        "bgColor": "bg-red-100",
        "textColor": "text-red-700"
    },
    {
        "errorType": "mechanical",
        "name": "Mechanical / Part แม่พิมพ์",
        "description": "เข็มกระทุ้งหัก, สกรูบูซเสีย, อินเสิร์ทแตก, ลิฟเตอร์เสีย, แผ่นรันเนอร์ไม่เด้ง ฯลฯ",
        "cause": "การใช้งานหนัก, การสึกหรอ, การจัดเก็บไม่เหมาะสม",
        "guidance": "เปลี่ยนอะไหล่, ตรวจสอบแรงฉีด, ตรวจสอบการประกอบใหม่",
        "bgColor": "bg-blue-100",
        "textColor": "text-blue-700"
    },
    {
        "errorType": "coolingSystem",
        "name": "ระบบน้ำและการระบายความร้อน",
        "description": "ข้อต่อน้ำรั่ว, น้ำไม่หมุนเวียน, ท่อน้ำตัน",
        "cause": "ตะกรัน, คราบสนิม, การออกแบบทางเดินน้ำไม่ดี",
        "guidance": "ล้างทางเดินน้ำ, เปลี่ยนข้อต่อ, อัพเกรดระบบระบายความร้อน",
        "bgColor": "bg-green-100",
        "textColor": "text-green-700"
    },
    {
        "errorType": "electrical",
        "name": "อุปกรณ์ไฟฟ้า/ความร้อน",
        "description": "ฮีตเตอร์ขาด, สายเทอร์โมขาด, สปริงแตก",
        "cause": "อายุการใช้งาน, ความชื้น, สายชำรุด",
        "guidance": "เปลี่ยนอะไหล่, ตรวจสอบระบบไฟฟ้าทั้งหมด",
        "bgColor": "bg-yellow-100",
        "textColor": "text-yellow-700"
    },
    {
        "errorType": "productDefect",
        "name": "ชิ้นงาน (Product Defect)",
        "description": "ฉีดไม่เต็ม, เป็นครีบ, รอยไหม้, Flow Mark, Eject Mark, สีลาย ฯลฯ",
        "cause": "อุณหภูมิไม่เหมาะสม, ช่องระบายอากาศ, การตั้งค่าการฉีด",
        "guidance": "ปรับพารามิเตอร์เครื่อง, ซ่อมแม่พิมพ์, ตรวจสอบจุดระบายแก๊สและเกท",
        "bgColor": "bg-purple-100",
        "textColor": "text-purple-700"
    }
]

export const getDisplayErrorType = (errorType: string): ErrorType | undefined => {
    const errorTypeObj = errorTypeList.find(type => type.errorType === errorType);
    return errorTypeObj;
}

export const getErrorCodeList = (): Promise<ButtonOption[]> => {
    return new Promise((resolve) => {
        const result = errorCodes.flatMap((errorCode) => {
            const errorTypeObj = getDisplayErrorType(errorCode.errorType);
            const groupName = errorTypeObj ? errorTypeObj.name : 'Unknown Error Type';
            const groupColor = errorTypeObj ? errorTypeObj.bgColor : 'bg-gray-100';
            const groupTextColor = errorTypeObj ? errorTypeObj.textColor : 'text-gray-700';
            return {
                value: errorCode.code,
                label: `${errorCode.code} - ${errorCode.description}`,
                group: groupName,
                bgColor: groupColor,
                textColor: groupTextColor,
            };
        });
        resolve(result);
    });
}

export const getErrorTypeFromCode = (errorCode: string): string => {
    if (!errorCode) {
        return '';
    }

    const item = errorCodes.find(item => item.code === errorCode);
    if (!item) {
        return '';
    }
    return item.errorType;
}

export const getRootCausesList = (): Promise<{value: string, label: string}[]> => {
    return new Promise((resolve) => {
        const rootCauses = [
            'ระบบไฟฟ้าขัดข้อง',
            'การบำรุงรักษาไม่เพียงพอ',
            'การใช้งานหนัก',
            'การสึกหรอ',
            'การจัดเก็บไม่เหมาะสม',
            'ตะกรัน',
            'คราบสนิม',
            'การออกแบบทางเดินน้ำไม่ดี',
            'อายุการใช้งาน',
            'ความชื้น',
            'สายชำรุด',
            'อุณหภูมิไม่เหมาะสม',
            'ช่องระบายอากาศ',
            'การตั้งค่าการฉีด',
            'ทับแม่พิมพ์',
            'ดีไซด์แม่พิมพ์',
            'การบำรุงรักษาไม่ถูกต้อง',
            'ไม่ได้พ่นสเปร์ย',
            'พ่นสเปร์ยไม่ทั่ว',
            'น้ำรั่ว',
            'น้ำตัน',
            'แมททีเรียลพิเศษ',
            'การซ่อมไม่หายขาด',
            'ผิวทรายหลุด',
            'ผิวทรายเป็นรอยข่วน',
            'การหล่อลื่นไม่เพียงพอ',
            'การกระทำของช่างฉีด',
            'การกระทำของช่างแม่พิมพ์',
            'การกระทำของช่างซ่อมบำรุง',
        ];
        const result = rootCauses.flatMap((rootCause) => {
            return {
                value: rootCause,
                label: rootCause,
            };
        });
        resolve(result);
    });
}
